import { Panel, Label } from '@playcanvas/pcui/react';
import React, { useState, useEffect, useRef } from 'react';

import { SetProperty, ObserverData } from '../../types';

const LiveriesPanel: React.FC<{
    liveriesData: ObserverData['liveries'],
    setProperty: SetProperty
}> = ({ liveriesData, setProperty }) => {
    const { available, selected, loading } = liveriesData;
    const [localSelected, setLocalSelected] = useState(selected);
    const isFirstRender = useRef(true);
    const [isCollapsed, setIsCollapsed] = useState(false);

    // Update local state when props change
    useEffect(() => {
        setLocalSelected(selected);
    }, [selected]);

    // Only use collapsed prop on first render - set to false to open by default
    const collapsedProp = isFirstRender.current ? { collapsed: false } : {};
    
    useEffect(() => {
        isFirstRender.current = false;
    }, []);

    return (
        <Panel headerText='LIVERIES' class='liveries-panel' collapsible={true} flexShrink={'0'} flexGrow={'0'} {...collapsedProp}>
            {loading && <Label text='Loading...' class='livery-loading' />}
            <div className='livery-list'>
                {available.map((liveryName: string) => {
                    const isSelected = localSelected === liveryName;
                    return (
                        <div
                            key={liveryName}
                            className={isSelected ? 'livery-item-selected' : 'livery-item'}
                            onClick={(e) => {
                                // Stop event from bubbling up to panel header
                                e.stopPropagation();
                                
                                // Update local state immediately
                                setLocalSelected(liveryName);
                                
                                // Update the observer
                                setProperty('liveries.selected', liveryName);
                            }}
                        >
                            {liveryName}
                        </div>
                    );
                })}
            </div>
        </Panel>
    );
};

export default LiveriesPanel;